import * as errors from '@attain-apps/errors'
import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type { Feature } from '../feature'

/**
 * When a render request is made, plugin attempts to execute the API request,
 * and send out the appropriate success or error action afterwards
 */
export const getRenderOnRequest = store.effects.create((feature: Feature) =>
  feature.actions.render.request.observe().pipe(
    rxjs.mergeMap(action => {
      // We get the rendering using the API
      const render$ = feature.api.renderPage(action.data)
      // TODO: after the first response, everything else should be a follow
      // up success or follow up error
      return render$.pipe(
        // Handles success
        rxjs.map(rendering =>
          rendering
            ? feature.actions.render.success.from(action).create({
                request: action.data,
                response: rendering,
              })
            : // NOTE: If API service returns "undefined" for page, we throw an error
              // This helps distinguish between "no-data" and "error" responses,
              // TODO: Consider moving error handling logic to the API service
              // instead of handling it at this level
              feature.actions.render.error.from(action).create({
                error: new errors.FailedOperationError({
                  description: 'load page',
                  reason: 'no rendering returned',
                }),
                request: action.data,
              }),
        ),
        // Handles error
        rxjs.catchError(error =>
          rxjs.of(
            feature.actions.render.error.from(action).create({
              error,
              request: action.data,
            }),
          ),
        ),
      )
    }),
  ),
)
